import { z } from "zod";

import i18n from "@/i18n";

export const partnerEditorSchema = z.object({
	name: z.string().trim().min(1, i18n.t("partners.nameRequired")),
	domainsText: z.string(),
	isActive: z.boolean(),
	domainDraft: z.string(),
});

export type PartnerEditorValues = z.infer<typeof partnerEditorSchema>;

export function emptyPartnerEditorValues(): PartnerEditorValues {
	return {
		name: "",
		domainsText: "",
		isActive: true,
		domainDraft: "",
	};
}
